<div class="card__main--web min-h-screen relative overflow-y-scroll no-scrollbar" id="launchPad">
  <app-navbar-new class="absolute top-0"></app-navbar-new>

  <div
    class="flex flex-col relative py-12 sm:py-16 md:py-20 lg:py-32 justify-start items-center flex-1 px-6 md:px-12 w-full container mx-auto">
    <img src="assets/landing-new/icons/star-sm.svg" class="absolute top-32 left-6 animate-blink" alt="" />
    <img src="assets/landing-new/icons/star-sm.svg"
      class="hidden lg:block lg:absolute top-96 w-12 h-12 left-20 xl:left-64 animate-blink" alt="" />
    <img src="assets/landing-new/icons/star-sm.svg"
      class="hidden lg:block lg:absolute top-48 right-16 lg:right-16 xl:right-32 animate-blink" alt="" />

    <img src="assets/landing-new/icons/star-sm.svg"
      class="hidden lg:block lg:absolute bottom-48 right-64 w-12 h-12 animate-blink" alt="" />
    <img src="assets/landing-new/icons/star-sm.svg" class="hidden lg:block lg:absolute bottom-8 left-32 animate-blink"
      alt="" />
    <img src="assets/landing-new/icons/star-sm.svg" class="absolute bottom-4 right-6 w-8 h-8 animate-blink" alt="" />

    <div class="pt-16 md:p-12 lg:pt-20 !pb-0 container mx-auto" *ngIf="isMenuActive == 0">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-12">
          <div class="relative text-center">
            <!-- <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink top-16 left-32 w-10 h-10" alt=""> -->
            <h2
              class="text__grey--gradient text-4xl sm:text-5xl md:text-5xl lg:text-7xl xl:text-8xl mi--font-regular invisible md:visible">
              Token Generator
            </h2>
            <p
              class="text-xl sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute bottom-0 inset-x-8 lg:inset-x-20">
              <span class="text__yg--gradient inline-block pb-0.5">Multi-feature token generator</span>
            </p>
            <!-- <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-16 right-32 w-10 h-10" alt=""> -->
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-0 md:gap-8 pt-8 pb-8">
        <div class="col-span-12">
          <p class="text-[#D9D9D9] text-sm text-center md:text-base lg:text-lg ep--font-light para-description">
            Our no-code token generator lets you create custom ERC20 <br />
            tokens with features you choose.
          </p>
          <div class="text-center flex items-center justify-center gap-2 pt-4">
            <img src="assets/icons/info.svg" alt="bx-finance" />
            <a href="https://www.youtube.com/watch?v=ydVPmx64RTU" target="_blank" class="text-primary-light text-base info-item">Demo Tutorial Video</a>
          </div>
        </div>
      </div>
    </div>

    <div class="pt-16 md:p-12 lg:pt-20 !pb-0 container mx-auto" *ngIf="isMenuActive == 1">
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12 md:col-span-12">
          <div class="relative text-center">
            <!-- <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink top-16 left-32 w-10 h-10" alt=""> -->
            <h2
              class="text__grey--gradient text-4xl sm:text-5xl md:text-5xl lg:text-7xl xl:text-8xl mi--font-regular invisible md:visible">
              Token Generator
            </h2>
            <p
              class="text-xl sm:text-2xl lg:text-3xl xl:text-4xl mi--font-regular absolute bottom-0 inset-x-8 lg:inset-x-20 pb-0.5">
              <span class="text__yg--gradient inline-block">Token Control Center</span>
            </p>
            <!-- <img src="assets/landing-new/icons/star-md.svg" class="hidden xl:block xl:absolute animate-blink bottom-16 right-32 w-10 h-10" alt=""> -->
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-0 md:gap-8 pt-8 pb-8">
        <div class="col-span-12">
          <p class="text-[#D9D9D9] text-sm text-center md:text-base lg:text-lg ep--font-light para-description">
            Paste your token address below to interact or change settings.
            <br />Control Center only supports tokens generated using BX
            Finance.
          </p>
          <div class="text-center flex items-center justify-center gap-2 pt-4">
            <img src="assets/icons/info.svg" alt="bx-finance" />
            <a href="https://www.youtube.com/watch?v=ydVPmx64RTU" target="_blank" class="text-primary-light text-base info-item">Demo Tutorial Video</a>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-0 mb-16 md:w-6/12 lg:w-5/12 m-auto">
      <ul
        class="flex flex-wrap w-fit m-auto bg-[#ffffff]/10 border border-solid border-[#191a1e] rounded-lg items-end justify-end p-1.5"
        id="launchPadTabs" data-tabs-toggle="#tradeFormTabContent" role="tablist">
        <li role="presentation">
          <button (click)="setActiveMenu(0)" class="{{
              isMenuActive == 0
                ? 'text-white bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] font-medium'
                : 'font-normal text-[#b1a7ca]'
            }} tab--pills text-base lg:text-lg p-2 px-4 rounded-md" id="createLaunchpad">
            Create Token
          </button>
        </li>
        <li role="presentation">
          <button (click)="setActiveMenu(1)" class="{{
              isMenuActive == 1
                ? 'text-white bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] font-medium'
                : 'font-normal text-[#b1a7ca]'
            }} tab--pills text-base lg:text-lg p-2 px-4 rounded-md" id="listLaunchpad">
            My Tokens
          </button>
        </li>
      </ul>
    </div>

    <!-- <div class="w-full container flex flex-col md:flex-row lg:w-5/6 xl:w-4/6 px-4 pt-12">
      <div class="card--info text-center md:text-left md:w-8/12 lg:w-7/12" *ngIf="isMenuActive == 0">
        <h2 class="font-bold text-white text-xl lg:text-2xl">Multi-feature token generator</h2>
        <p class="font-semibold text-base xl:text-lg text-secondary pt-2">Our no-code token generator lets you create custom ERC20 tokens with features you choose.</p>
      </div>
      <div class="card--info text-center md:text-left md:w-8/12 lg:w-7/12" *ngIf="isMenuActive == 1">
        <h2 class="font-bold text-white text-xl lg:text-2xl">Token Control Center</h2>
        <p class="font-semibold text-base xl:text-lg text-secondary pt-2">Paste your token address below to interact or change settings. Control Center only supports tokens generated using BX Finance.</p>
      </div>
      <div class="mt-4 lg:mt-0 lg:mb-4 md:w-4/12 lg:w-5/12">
        <ul
          class="flex flex-wrap w-fit m-auto md:mr-0 bg-[#ffffff]/10 border border-solid border-[#191a1e] rounded-lg items-end justify-end p-1.5"
          id="launchPadTabs" data-tabs-toggle="#tradeFormTabContent" role="tablist">
          <li role="presentation">
              <button (click)="setActiveMenu(0)"
                  class="{{ isMenuActive == 0 ? 'text-white bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] font-medium':'font-normal text-[#b1a7ca]' }} tab--pills text-xs lg:text-sm p-2 px-4 rounded-md"
                  id="createLaunchpad">Create Token</button>
          </li>
          <li role="presentation">
              <button (click)="setActiveMenu(1)"
                  class="{{ isMenuActive == 1 ? 'text-white bg-[#4E1FA3]/30 border border-solid border-[#4e1fa3] font-medium':'font-normal text-[#b1a7ca]' }} tab--pills text-xs lg:text-sm p-2 px-4 rounded-md"
                  id="listLaunchpad">My Tokens</button>
          </li>
        </ul>
      </div>
    </div> -->

    <!-- BEGIN: Create Token Screens -->
    <div class="w-full px-0 md:px-4 lg:w-6/6" *ngIf="isMenuActive == 0">
      <app-create-token></app-create-token>
    </div>
    <!-- END: Create Token Screens -->

    <!-- BEGIN: Launchpad List -->
    <div class="w-full px-0 md:px-4 lg:w-6/6" *ngIf="isMenuActive == 1">
      <app-my-tokens></app-my-tokens>
    </div>
    <!-- END: Launchpad List -->
  </div>
</div>